import { DialogContent, styled } from '@mui/material';

export const DialogContentStyled = styled(DialogContent)`
  display: grid;
  gap: 8px;
  overflow: visible;
`;
